import React from 'react';
import { Row, Col, Input, Button } from '../../components/AntDReplacements';

const TextArea = Input.TextArea;
const styles = {
	wrapper: {
		marginTop: '20px',
		marginBottom: '40px',
	},
};

//TODO: Cleanup this styles mess
export const GiftVouchersSection = ({
	giftVouchers,
	updateGiftVoucher,
	removeGiftVoucher,
	addGiftVoucher,
}) => (
	<div style={styles.wrapper}>
		<Row>
			<Col>Geschenkgutscheine</Col>
		</Row>
		<Row style={{ margin: '10px 0' }}>
			{Object.entries(giftVouchers).map(([key, { image, description, title, price }]) => (
				<Col span={7} key={key} style={{ marginBottom: '10px', marginLeft: '10px' }}>
					<Input
						value={title}
						placeholder="Titel..."
						onChange={(event) => updateGiftVoucher(key, 'title', event.target.value)}
					/>
					<Input
						value={price}
						placeholder="Preis... "
						onChange={(event) => updateGiftVoucher(key, 'price', event.target.value)}
					/>
					<TextArea
						value={description}
						placeholder="Beschreibung..."
						onChange={(event) => updateGiftVoucher(key, 'description', event.target.value)}
					/>
					<Input
						value={image}
						placeholder="Url des Bildes..."
						onChange={(event) => updateGiftVoucher(key, 'image', event.target.value)}
					/>
					<Button type="danger" onClick={() => removeGiftVoucher(key)}>
						Löschen
					</Button>
				</Col>
			))}
		</Row>
		<Row>
			<Col>
				<Button type="dashed" icon="plus-circle-o" onClick={() => addGiftVoucher({})} />
			</Col>
		</Row>
	</div>
);
